<template>
  <div>
    <div v-if="loading">
      <p>Loading</p>
    </div>
    <div v-else>
      <img :src="imageurl" v-if="image" class="image" />

      <div class="container">
        <div class="title">
          <h2 class="name">{{ shoe.name }}</h2>

          <p class="price" v-if="!shoe.discount">
            € {{ shoe.price.toFixed(2) }}
          </p>

          <div class="price" v-else>
            <del>
              <span class=" oldprice">€ {{ shoe.price.toFixed(2) }}</span>
            </del>
            <ins>
              <span v-if="shoe.discount"
                >€ {{ shoe.sales_price.toFixed(2) }}
              </span>
            </ins>
          </div>
        </div>

        <p class="description">{{ shoe.description }}</p>
      </div>
      <div class="measures">
        <h2 class="numberstitle">Disponibilità numeri</h2>
        <hr />
        <div class="chipscont">
          <div class="chips" v-for="measure in numbers" :key="measure.number">
            <span class="number">
              {{ measure.number }}
            </span>
            <span class="av"> {{ measure.availability }} </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Details",
  data: function() {
    return {
      loading: true,
      shoe: null,
      image: null
    };
  },
  computed: {
    imageurl: function() {
      return process.env.VUE_APP_BACKEND + this.image.full;
    },
    numbers: function() {
      return this.shoe.measures.filter(el => el.availability > 0);
    }
  },
  mounted: function() {
    this.loading = true;
    this.shoe = this.$store.getters.shoe(this.$route.params.id);
    if (this.shoe.image == "" || !this.shoe.image) {
      console.log("No image");
    } else {
      this.image = this.$store.getters.image(this.shoe.image);
    }
    console.log(this.shoe);
    this.loading = false;
  }
};
</script>

<style scoped>
.image {
  display: block;
  width: 100%;
  height: 50vh;
  object-fit: cover;
  box-shadow: 0 3px 6px #bebebe;
  margin-bottom: 20px;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.price {
  display: block;
  padding: 20px;
  flex-shrink: 0;
}

.description {
  white-space: pre-wrap;
}

.container {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}

.measures {
  margin-top: 50px;
  background-color: #f4f4f4;
  padding: 20px 40px 40px;
  border-top: solid 5px #a8a8a8;
  text-align: left;
}

.numberstitle {
  font-weight: 300;
  margin: 0;
}

.measures hr {
  border: 0.5px solid #707070;
  width: 10%;
  margin: 5px 0 30px;
}

.chipscont {
  display: flex;
  flex-wrap: wrap;
}

.chips {
  background-color: #66b17d;
  margin-right: 10px;
  margin-bottom: 20px;
  padding: 7px 0 5px 10px;
  border-radius: 10px;
  color: white;
  box-shadow: 0 0 10px #a8a8a8;
}

.number {
  margin-right: 5px;
}

.av {
  background-color: #bcbcbc;
  padding: 10px;
  border-radius: 10px;
}

del {
  text-decoration: none;
  position: relative;
  width: 100%;
  display: block;
  margin-bottom: 10px;
  text-align: center;
}

ins {
  color: green;
  text-decoration: none;
  padding: 1em;
  font-size: 1.1em;
  text-align: center;
}
.oldprice {
  text-decoration: none;
  position: relative;
  color: red;
}

.oldprice::before {
  top: 50%; /*tweak this to adjust the vertical position if it's off a bit due to your font family */
  background: red; /*this is the color of the line*/
  opacity: 0.7;
  content: "";
  width: 110%;
  position: absolute;
  height: 0.1em;
  border-radius: 0.1em;
  left: -5%;
  white-space: nowrap;
  display: block;
  transform: rotate(-15deg);
}

.oldprice.straight::before {
  transform: rotate(0deg);
  left: -1%;
  width: 102%;
}
</style>
